'use strict';

const {provideContext, connectToStores} = require('fluxible-addons-react');
const FavoritePageStore = require('../../global/stores/FavoritePageStore');

const connectToStoresHelper = function ({component, stores, type, mapStateToProps}) {
    return provideContext(connectToStores(
        component,
        [FavoritePageStore, ...stores || []],
        function (context) {
            const store = context.getStore(FavoritePageStore);

            return Object.assign(mapStateToProps ? mapStateToProps(context) : {}, {
                id: store.getFavoriteId(type),
                isSaved: store.isSaved(type),
                isFetched: store.isFetched(type),
                isCanceled: store.isCanceled()
            });
        }
    ));
};

module.exports = connectToStoresHelper;



// WEBPACK FOOTER //
// ./assets/js/components/FavoriteCta/connectToStoresHelper.es.js